module.exports = __webpack_public_path__ + "img/aParty_032523_I.457957ba.jpg";